import React from 'react'
import {
  TextField,
  FormControlLabel,
  Checkbox,
  Tooltip,
  Input,
} from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import DurationInput from '../Step2-BreakRuleSection/DurationInput';

/**
 * @typedef {{
*  label: string,
*  placeholder: string,
*  isOverride: boolean,
*  setIsOverride: (value: boolean) => void,
*  overrideValue: number,
*  setOverrideValue: (value: number) => void,
*  helpIconTooltip?: string,
*  isDisabled?: boolean,
* }} OverrideDurationProps
* @param {OverrideDurationProps} props 
*/
const OverrideDuration = ({label, placeholder, isOverride, setIsOverride, overrideValue, setOverrideValue, helpIconTooltip, isDisabled}:props) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>            
      <FormControlLabel
        control={(
          <Checkbox checked={isOverride} onClick={({ target: { checked: isChecked } }) => {setIsOverride(isChecked)}}/>
        )}
        label={label}
        disabled={isDisabled}
      />
      <div style={{ marginRight: '16px' }}>
        <DurationInput
            onChange={(value) => setOverrideValue(value * 60)}
            value={ overrideValue / 60}
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            disabled={isDisabled || !isOverride}
            placeholder={placeholder}
        />
      </div>
      <Tooltip title={helpIconTooltip} arrow>
          <HelpIcon fontSize="small" />
      </Tooltip>
    </div>
  )
}

export default OverrideDuration